import { ChangeDetectionStrategy, Component, input, model } from '@angular/core'
import { FormValueControl } from '@angular/forms/signals'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

/**
 * Auswahl eines Dokuments (PDF oder Bild).
 *
 * ⚠️ **Hat aktuell keinen Aufrufer** (Stand 2026-08-18) — vor dem Weiterbauen pruefen, ob die
 * Komponente ueberhaupt noch gebraucht wird oder besser entfaellt.
 */
@Component({
  selector: 'lib-doc-input',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './doc-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './doc-input.component.scss',
})
export class DocInputComponent implements FormValueControl<File | null> {
  readonly value = model<File | null>(null)

  readonly accept = input<string>('application/pdf,image/*')
  readonly label = input<string>('Bild oder PDF auswählen')

  setFile(file?: File) {
    this.value.set(file ?? null)
  }
}
